export function PageTitle({ children, action, testid }) {
  return (
    <div className="ak-title-wrap flex items-center justify-between gap-3 mb-5">
      <div>
        <h1 className="ak-title font-heading text-2xl sm:text-3xl tracking-tight" data-testid={testid}>{children}</h1>
        <span className="avalon-line mt-2" aria-hidden="true" />
      </div>
      {action}
    </div>
  );
}

export function BigButton({ children, variant = "primary", className = "", ...props }) {
  const styles = {
    primary: "bg-primary hover:bg-[#1F6AB0] text-white",
    gold: "orbit-gold-btn text-[#1A1A1A]",
    green: "bg-[#1F9D55] hover:bg-[#188548] text-white",
    amber: "bg-[#E67E22] hover:bg-[#CF6D17] text-white",
    soft: "bg-white border border-[#0B2A5B]/30 text-[#0B2A5B] hover:bg-secondary",
    danger: "bg-destructive text-white",
  };
  return (
    <button
      type="button"
      className={`ak-btn ak-btn-${variant} h-14 px-6 rounded-full text-base sm:text-lg font-bold flex items-center justify-center gap-2 transition-[background-color,transform] active:scale-[0.98] disabled:opacity-40 disabled:pointer-events-none ${styles[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Chip({ active, children, className = "", ...props }) {
  return (
    <button
      type="button"
      className={`ak-chip ${active ? "ak-on" : ""} shrink-0 h-11 px-4 rounded-full border text-sm font-semibold flex items-center gap-1.5 transition-colors ${active ? "bg-[#0B2A5B] text-white border-[#0B2A5B]" : "bg-white border-border hover:border-[#0B2A5B]/40"} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="ak-label block text-sm font-medium mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export const inputCls = "w-full h-12 rounded border border-border bg-white px-3 text-base focus:outline-none focus:ring-1 focus:ring-[#0078D7] ak-input";

export function Empty({ icon: Icon, text, testid }) {
  return (
    <div className="text-center py-12 text-muted-foreground" data-testid={testid}>
      {Icon && <Icon className="w-12 h-12 mx-auto mb-2 opacity-40" />}
      <p className="font-medium">{text}</p>
    </div>
  );
}

export function Stat({ label, value, icon: Icon, tone = "#0B2A5B", testid }) {
  return (
    <div className="ak-card rounded-xl bg-white border border-border p-4 card-soft rise flex items-start gap-3">
      {Icon && (
        <span className="w-11 h-11 rounded-lg grid place-items-center shrink-0" style={{ background: `${tone}14`, color: tone }}>
          <Icon className="w-5 h-5" />
        </span>
      )}
      <div className="min-w-0">
        <div className="text-xs sm:text-sm text-muted-foreground">{label}</div>
        <div className="text-xl sm:text-2xl font-semibold tracking-tight mt-0.5 truncate" data-testid={testid}>{value}</div>
      </div>
    </div>
  );
}
